
import { BriefcaseIcon, CreditCardIcon, HomeIcon, UserPlusIcon, UsersIcon, VideoCameraIcon } from '@heroicons/react/24/solid'
import { useNavigate } from 'react-router-dom'

export default function SideBar({ mobileMenu }) {

  const navigate = useNavigate();

  const gotToPage = (path) => {
    navigate(path)
  }

 

  

  const items = [
    {
      title: 'Dashboard',
      icon: <HomeIcon className="h-5 w-5" />,
      route: '/admin/dashboard'
    },

    {
      title: 'Users',
      icon: <UsersIcon className="h-5 w-5" />,
      route: '/admin/users/'
    },
    {
      title: 'Neutrals',
      icon: <UserPlusIcon className="h-5 w-5" />,
      route: '/admin/neutrals'
    },
    {
      title: 'Cases',
      icon: <BriefcaseIcon className="h-5 w-5" />,
      route: '/admin/cases'
    },
    {
      title: 'Proceedings',
      icon: <VideoCameraIcon className="h-5 w-5" />,
      route: '/admin/proceedings'
    },
    {
      title: 'Transactions',
      icon: <CreditCardIcon className="h-5 w-5" />,
      route: '/admin/transactions'
    }
  ]
  return (
    <>
      <section className="xl:w-64 md:w-72 hidden md:block blue-bg text-white text-sm font-semibold h-full overflow-y-scroll">
        <div className="title h-16 py-3 flex gap-1 justify-start items-center flex-row border-b px-4 border-blue-100">
          <img src="https://res.cloudinary.com/eskwaya-lawtech/image/upload/v1667746121/logo_o0paoh.png" className="h-6 w-28" alt="" />
          <span className='font-fira font-semibold text-xl'>-</span>
          <span className="font-fira font-semibold text-xs xl:text-sm">Admin</span>
        </div>
        <div className="mt-3">
          <ul>
            {items.map((nav) => (<li key={nav.title} className="px-6 cursor-pointer py-4 hover:bg-blue-900">
              <div onClick={() => {
                gotToPage(nav.route)
              }} className="flex items-end gap-3 justify-start">
                <span>
                  {nav.icon}
                </span>
                <span>
                  {nav.title}
                </span>
              </div>
            </li>))}
          </ul>
        </div>
      </section>

      {mobileMenu && <section className="animate__animated fixed top-18 w-full animate__fadeIn md:hidden z-10 bg-white text-gray-800 text-sm font-semibold h-full overflow-hidden">
        <div className="title h-16 py-3 flex gap-1 justify-start items-center flex-row border-b px-4 border-blue-100">
          <img src="https://res.cloudinary.com/eskwaya-lawtech/image/upload/v1667746121/logo_o0paoh.png" className="h-6 w-28" alt="" />
          <span className='font-fira font-semibold text-xl'>-</span>
          <span className="font-fira font-semibold text-xs xl:text-xl">Admin</span>
        </div>
        <div className="mt-3">
          <ul>
            {
              items.map((nav) => (<li key={nav.title} className="px-6 cursor-pointer border-b border-gray-800 py-4 hover:bg-gray-200">
                <div onClick={() => gotToPage(nav.route)} className="flex items-end gap-3 justify-start">
                  <span>
                    {nav.icon}
                  </span>
                  <span>
                    { nav.title }
                  </span>
                </div>
              </li>))
            }
          </ul>
        </div>
      </section>}
    </>
  )
}
